
:host {
  background-color: var(--cms-teaser-background);
  grid-area: var(--cms-default-grid-area);
}

.text-wrapper {
  background-color: var(--cms-teaser-background);
  padding: 0 1rem 1rem;

  &.no-margin p {
    margin-top: 0px;
  }
}

.teaser-content-wrapper {
  position: relative;
  background-color: var(--cms-semanticColors-base-medium-background);
  padding: 1rem 1rem 0;
}

.teaser-link {
  display: block;
  height: 100%;
  color: var(--cms-semanticColors-base-medium-textOnBackground);
  text-decoration: none;
}

.badge-wrapper {
  z-index: 1;
  position: absolute;
  top: 1rem;
}

.scratch { 
  min-height: 3px;
  height: 5px;
  display: flex;
  position: absolute;
  top: -6px;
  left: 0;
  z-index: 100;
  width: 100%;
  
  svg path {
    fill: var(--cms-semanticColors-base-medium-background);
  }
}

.download-pdf-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 1rem;
  text-align: center;
  border-top: 0.0625rem solid var(--cms-semanticColors-base-medium-border);

  .pdf-label {
    font-family: var(--cms-brandfont2);
    font-size: var(--cms-font-size-112);
    line-height: var(--cms-line-height-112);
    font-weight: var(--cms-heading-base-font-weight);
    margin-left: var(--cms-spacing-050);
  }
}